import { useEffect, useState } from 'react'
import { api } from '../services'
import { Spinner } from './Spinner'

export function UserSettingsWaterThresholds() {
  // alert settings on user profile is a completely different beast
  // need to manage user account settings in a different way
  // so retrieve it from the backend and store it on the backend
  const [isLoading, setIsLoading] = useState(false)
  const [settings, setSettings] = useState([
    {
      name: 'water-level-high-trigger',
      type: 'Water IN Trigger (%)',
      value: 25,
    },
    {
      name: 'water-level-low-trigger',
      type: 'Water OUT Trigger (%)',
      value: 15,
    },
    {
      name: 'hysteresis',
      type: 'Hysteresis (%)',
      value: '...',
    },
  ])

  useEffect(() => {
    setIsLoading(true)
    api
      .getHysteresisSettings()
      .then((result) => {
        const updatedSettings = settings.map((setting) => {
          setting.value = setting.value === result[setting.name] ? setting.value : result[setting.name]
          return setting
        })
        setSettings(updatedSettings)
      })
      .catch((error) => {
        console.error(error)
      })
      .finally(() => {
        setIsLoading(false)
      })

    return () => {}
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  function updateSettings(name: string, value: number) {
    switch (name) {
      case 'hysteresis':
        updateHysteresisSettings(value)
        break
      default:
        console.error('Case not handled', { name: value })
        break
    }
  }

  function updateHysteresisSettings(value: number) {
    setIsLoading(true)
    api
      .updateHysteresisSettings(value)
      .then((data) => {
        const updatedSettings = settings.map((setting) => {
          setting.value = setting.value === data[setting.name] ? setting.value : data[setting.name]
          return setting
        })
        setSettings(updatedSettings)
      })
      .catch((error) => {
        console.error(error)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <div className="mb-10">
      <div className={tailwind.header}>
        Water Thresholds and Hysteresis
        <div className="pt-1">{isLoading && <Spinner size={20} color="white" />}</div>
      </div>
      <table className={tailwind.table}>
        <tbody>
          {settings.map((setting, index) => {
            return (
              <tr key={index}>
                <td className={tailwind.label}>{setting.type}</td>
                <td className={tailwind.input}>
                  <input
                    className={tailwind.inputText}
                    type="number"
                    value={setting.value}
                    id={setting.name}
                    placeholder="..."
                    onChange={(e) => {
                      updateSettings(setting.name, Number(e.target.value))
                    }}
                  />
                </td>
                <td></td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

const tailwind = {
  header: 'flex flex-auto justify-between text-black text-l font-regular bg-[#BBB] py-2.5 pl-4 pr-4 w-full mb-4',
  table: 'w-full mx-3',
  inputText:
    'appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none',
  label: 'px-3 w-[260px]',
  input: 'w-24',
  icon: 'pl-3',
}
